// extracted by mini-css-extract-plugin
module.exports = {"label":"LongTextQuestionDetail_label__XHlED"};